import delegate from '../../../lib/dom/delegate';
import AbstractFilter from '../AbstractFilter';
import { FILTER_EVENT } from '../FilterEvent';

export default class FilterPagination extends AbstractFilter {
  constructor(...args) {
    super(...args);

    this._getDom();
    this._bind();
  }

  _getDom() {
    this._dom.link = this._dom.container.querySelectorAll(
      '.js-link-pagination',
    );
  }

  _bind() {
    delegate(
      this._dom.container,
      '.js-link-pagination',
      'click',
      this._clickHandler.bind(this),
    );
  }

  _clickHandler(e) {
    e.preventDefault();
    const choice = e.delegateTarget;
    this._values = [choice.getAttribute('data-value')];
    this.emit(FILTER_EVENT.CHANGED, { interactive: true });
    this.emit(FILTER_EVENT.AUTO_SUBMIT);
  }

  isMultiple() {
    return false;
  }
}
